import http from '../Http';
import { useContext, useState, useRef } from 'react';
import utils from '../utils';
import { Modal, Button, Input, Form, Select, Switch } from 'antd';
import InputPrefix from '../utils/InputPrefix';
import { useTranslation } from 'react-i18next';

function DistributorUserAdder (props) {
    const { t } = useTranslation();
    const setTip = useContext(utils.tipContext);

    const {show, onClose} = props;

    const [form] = Form.useForm();

    const [distributorSelectOptions, setDistributorSelectOptions] = useState([]);

    const refTimerDistributorSearcher = useRef(null);
    const refDistributorSearchValue = useRef(null);

    const handleCancle = () => {
        onClose(null);
    }

    const handleSubmit = async () => {
        const ps = await form.validateFields().catch(() => {return null});
        
        if (ps === null) {
            return;
        }

        ps.Enabled = ps.Enabled ? 1 : 0;
        ps.Name = encodeURIComponent(ps.Name) || "";
        ps.Phone = encodeURIComponent(ps.Phone) || "";
        ps.EMail = encodeURIComponent(ps.EMail) || "";
        ps.Address = encodeURIComponent(ps.Address) || "";
        

        const resp = await http.post("user/management/distributor-user/add", ps).then(async (r)=>{
            return await r.json();
        }).catch((e) => {
            console.log("[UserAdd]", e);
            return null;
        });

        try {
            if (resp.code !== 200) {
                setTip({open:true, severity:"error", msg:(resp && resp.msg) ? resp.msg : t("add error")});
                return
            }

            setTip({open: true, severity: 'success', msg: t('add success')});

            ps.CreateTime = resp.data.CreateTime;
            ps.DistributorName = (resp.data.DistributorName || "");
            ps.Timezone = (resp.data.Timezone || "");
            ps.GmtOffset = (resp.data.GmtOffset || "");
            ps.Role="DistributorUser";
            onClose(ps);
        } catch (e) {
            console.log("[UserAdd]", e);

            setTip({open:true, severity:"error", msg: t("add error")});
        }
    }

    const handleSearchDistributor = (v) => {
        if (refTimerDistributorSearcher.current != null) {
            clearTimeout(refTimerDistributorSearcher.current);
        }
        refDistributorSearchValue.current = v;

        refTimerDistributorSearcher.current = setTimeout(async () => {
            const resp = await http.post("distributor/name/list", {
                Value: encodeURIComponent(v),
            }).then(async(r) => {
                return await r.json();
            }).catch((e) => {
                console.log("[DeviceAdd]", e);
                return null;
            });

            if (refDistributorSearchValue.current !== v) {
                return;
            }

            try {
                if (resp.code !== 200) {
                    setTip({open:true, severity:"error", msg:(resp && resp.msg) ? resp.msg : t("load distributor list error")});
                    return;
                }

                const ls = resp.data.map(({Name, ID}) => {
                    return (
                        <Select.Option key={ID} value={ID}>{Name}</Select.Option>
                    );
                });
                setDistributorSelectOptions(ls);
            } catch(e) {
                console.log("[DeviceAdd]", e);

                setTip({open:true, severity:"error", msg: t("load distributor list error")});
            }
        }, 300);
    }

    return (<Modal 
        title={t("Add Distributor User")}
        visible={show}
        cancelText={t("Cancel")}
        okText={t("Submit")}
        mask={true}
        maskClosable={false}
        width={500}
        onCancel={handleCancle}
        onOk={handleSubmit}
        footer={[
            <Button 
                key="Clear" 
                shape="round"
                onClick={() => {
                    form.resetFields();
                }}
            >{t("Clear")}</Button>,
            <Button key="Cancel" shape="round" onClick={handleCancle}>{t("Cancel")}</Button>,
            <Button key="Submit" shape="round" type="primary" onClick={handleSubmit}>{t("Submit")}</Button>
        ]}
    >
        <Form
            labelAlign="right"
            labelCol={{ span: 4 }}
            wrapperCol={{ span: 25 }}
            form={form}
            initialValues={{
                Enabled: true,
            }}
        >
            <Input.Group compact>
                <Button><span style={{color: 'red', verticalAlign: 'middle', marginRight: '5px'}}>*</span>{t("Distributor")}</Button>
                <Form.Item 
                    name="DistributorID"
                    label=""
                    rules={[{ required: true }]}
                    style={{width: 'calc(100% - 108px'}}
                >
                    <Select 
                        showSearch
                        placeholder={t("Enter Distributor Name")}
                        defaultActiveFirstOption={false}
                        showArrow={false}
                        filterOption={false}
                        onSearch={handleSearchDistributor}
                    >{distributorSelectOptions}</Select>
                </Form.Item>
            </Input.Group>
            <Form.Item 
                name="Name"
                label=""
            >
                <Input prefix={<InputPrefix label={t("Title")} />} style={{ borderRadius: '20px' }} />
            </Form.Item>
            <Form.Item 
                name="ID"
                label=""
                rules={[{ required: true, min: 3 }]}
            >
                <Input prefix={<InputPrefix label={t("UserID")} required />} style={{ borderRadius: '20px' }} />
            </Form.Item>
            <Form.Item 
                name="Password"
                label=""
                rules={[{ required: true, min: 6 }]}
            >
                <Input prefix={<InputPrefix label={t("Password")} required />} placeholder={t("Login Password")} style={{ borderRadius: '20px' }} />
            </Form.Item>
            <Form.Item 
                name="Phone"
                label=""
            >
                <Input prefix={<InputPrefix label={t("Phone")} />} placeholder={t("Phone Number")} style={{ borderRadius: '20px' }} />
            </Form.Item>
            <Form.Item 
                name="EMail"
                label=""
            >
                <Input prefix={<InputPrefix label={t("E-Mail")} />} style={{ borderRadius: '20px' }} />
            </Form.Item>
            <Form.Item 
                name="Address"
                label=""
            >
                <Input prefix={<InputPrefix label={t("Address")} />} style={{ borderRadius: '20px' }} />
            </Form.Item>
            <Form.Item 
                name="Enabled"
                label={t("Enabled")}
                valuePropName="checked"
            >
                <Switch />
            </Form.Item>
        </Form>
    </Modal>);
}

export default DistributorUserAdder;